import { render } from "./AuthBlock.vue?vue&type=template&id=1f44842a"
import script from "./AuthBlock.vue?vue&type=script&lang=js"
export * from "./AuthBlock.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/automation-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__